var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg99(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2.25C4.00736 2.25 3 3.25736 3 4.5V7.62803C2.12611 7.93687 1.5 8.77035 1.5 9.75V19.5C1.5 20.7427 2.50736 21.75 3.75 21.75H17.25C18.4927 21.75 19.5 20.7427 19.5 19.5V19.0639C18.8052 19.3451 18.0457 19.5 17.25 19.5C13.9363 19.5 11.25 16.8137 11.25 13.5C11.25 12.0811 11.7425 10.7772 12.566 9.75H11.5606L9.96968 8.15903C9.54772 7.73708 8.9754 7.5 8.3787 7.5H4.5V4.5C4.5 4.08579 4.83579 3.75 5.25 3.75H15.75C16.1642 3.75 16.5 4.08579 16.5 4.5V7.54642C16.7457 7.51575 16.996 7.5 17.25 7.5C17.504 7.5 17.7543 7.51575 18 7.54642V4.5C18 3.25736 16.9927 2.25 15.75 2.25H5.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5C5.58579 4.5 5.25 4.83579 5.25 5.25C5.25 5.66421 5.58579 6 6 6H7.5C7.91423 6 8.25 5.66421 8.25 5.25C8.25 4.83579 7.91423 4.5 7.5 4.5H6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 8.25C20.1495 8.25 22.5 10.6005 22.5 13.5C22.5 16.3995 20.1495 18.75 17.25 18.75C14.3505 18.75 12 16.3995 12 13.5C12 10.6005 14.3505 8.25 17.25 8.25ZM15.3 12.525C14.9686 12.7736 14.9015 13.2437 15.15 13.575C15.3986 13.9064 15.8687 13.9735 16.2 13.725L16.5 13.5V15C16.5 15.4142 16.8358 15.75 17.25 15.75C17.6642 15.75 18 15.4142 18 15V13.5L18.3 13.725C18.6313 13.9735 19.1014 13.9064 19.35 13.575C19.5985 13.2437 19.5314 12.7736 19.2 12.525L17.7 11.4C17.4333 11.2 17.0667 11.2 16.8 11.4L15.3 12.525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg99);
export default __webpack_public_path__ + "static/media/svg99.6e8ec194351f9a385f86f47046e8e554.svg";
export { ForwardRef as ReactComponent };